export default __webpack_public_path__ + "static/media/mediaNews.65c6f61a.svg";